import React from 'react';
import { useTheme } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';
import {
  LOGO_FULL,
  SKYSPECS_BRAND_LOGO,
  SKYSPECS_BRAND_LOGO_WHITE,
  SKYSPECS_LOGO,
  SKYSPECS_LOGO_WHITE,
} from 'utils/constants';
import { MAINTENANCE_MODE_ENABLED } from 'utils/env';

import { MaintenanceContainer, PrimaryLogo, SkySpecsLogo } from './Maintenance.style';

interface Props {
  children: React.ReactNode;
}

function Maintenance({ children }: Props) {
  const theme = useTheme();
  const isDark = theme.themeName === Theme.Dark;
  // On the dark theme the maintenance background is dark, so use the white brand
  // logo variants (matching SideNav / GlobalFooter) to keep them legible.
  const brandLogo = isDark ? SKYSPECS_BRAND_LOGO_WHITE : SKYSPECS_BRAND_LOGO;

  if (!MAINTENANCE_MODE_ENABLED) {
    return <>{children}</>;
  }

  return (
    <MaintenanceContainer>
      <PrimaryLogo
        alt={theme.isHorizonGridVisualRefresh ? 'skyspecs-logo' : 'horizon-logo'}
        src={theme.isHorizonGridVisualRefresh ? brandLogo : LOGO_FULL}
      />
      <main>
        <h1>Sorry! We're currently down for maintenance.</h1>
        <h2>We'll be back up as soon as possible.</h2>
        <p>
          Questions?{' '}
          <a
            href="https://support.skyspecs.com/hc/en-us/requests/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Support
          </a>
        </p>
      </main>
      <SkySpecsLogo
        alt="skyspecs-logo"
        src={
          theme.isHorizonGridVisualRefresh
            ? brandLogo
            : isDark
              ? SKYSPECS_LOGO_WHITE
              : SKYSPECS_LOGO
        }
      />
    </MaintenanceContainer>
  );
}

export default Maintenance;
